var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-square",
    transform: "translate(0.469 0.469)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7424",
    "data-name": "Rectangle 7424",
    width: 20,
    height: 20,
    transform: "translate(-0.469 -0.469)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7425",
    "data-name": "Rectangle 7425",
    width: 14,
    height: 14,
    rx: 3,
    transform: "translate(2.531 2.531)",
    fill: "none",
    stroke: "#7a8797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65179",
    "data-name": "Path 65179",
    d: "M53.766,118.809,50.457,115.5a.626.626,0,0,0-.892,0l-3.488,3.488a.626.626,0,0,1-.892,0l-1.611-1.611a.626.626,0,0,0-.892,0L40,120.06",
    transform: "translate(-36.973 -106.395)",
    fill: "none",
    stroke: "#7a8797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_628",
    "data-name": "Ellipse 628",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(6.531 5.531)",
    fill: "#7a8797"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSquare);
export default __webpack_public_path__ + "static/media/image-square.a4c115efb2057383c46e4a561ba2dd57.svg";
export { ForwardRef as ReactComponent };